import React from 'react'
import './PropertyListItem.scss'
import { Apartment, Room } from '@material-ui/icons'
import Icon from '@material-ui/core/Icon'
import PropTypes from 'prop-types'
import DeleteIcon from '@material-ui/icons/Delete'
import WarningIcon from '@material-ui/icons/ReportProblemOutlined'
import { red } from '@material-ui/core/colors'
import Tooltip from '@material-ui/core/Tooltip'
import { connect } from 'react-redux'
import Comps from '@engine/comps'
// import AutorenewIcon from '@material-ui/icons/Autorenew'
export class PropertyListItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isHovered: false
    }
  }

  clearSelection = e => {
    const target = e.currentTarget
    target.className = 'property-list__item'
  }

  render() {
    const {
      property,
      isSubject,
      originalIndex,
      orderIndex,
      isDragging,
      onDragOver,
      onDragStart,
      onDrop,
      dragMode,
      gotoPropertyPreview,
      onDelete,
      enableDelete
      // hasUnSavedChanges
    } = this.props
    const { isHovered } = this.state
    // const { fieldsForOvSync } = property
    // const isPropertyReadyForOvSync = !hasUnSavedChanges && (fieldsForOvSync?.isNameModified || fieldsForOvSync?.isNotesModified || fieldsForOvSync?.isUnitMixModified)

    // console.log('****** property.name *****', property.name)
    // console.log('------isPropertyReadyForOvSync-----', isPropertyReadyForOvSync)
    // console.log('------!hasUnSavedChanges-----', !hasUnSavedChanges)
    // console.log('------fieldsForOvSync?.isNameModified -----', fieldsForOvSync?.isNameModified)
    // console.log('------fieldsForOvSync?.isNotesModified-----', fieldsForOvSync?.isNotesModified)
    // console.log('------fieldsForOvSync?.isUnitMixModified-----', fieldsForOvSync?.isUnitMixModified)
    // console.log('***********')

    return <React.Fragment>
        <div data-testid={`property-list-item-${property.propertyType}`} onClick={() => gotoPropertyPreview(property.propertyType)} className={`property-list__item ${dragMode ? '' : 'no-drag'}`} onMouseEnter={() => this.setState(
              { isHovered: true }
            )} onMouseLeave={() => this.setState({
              isHovered: false
            })} onDragOver={onDragOver(originalIndex, isSubject)} onDragStart={onDragStart(originalIndex, isSubject)} onDrop={onDrop(orderIndex, isSubject)} onDragLeave={e => this.clearSelection(e)} is-hovered={String(isHovered)} is-subject={String(isSubject)} draggable={true} style={{ cursor: isDragging ? 'grabbing' : 'grab' }}>
          <div>
            {isHovered ? (
              <Icon className="fa fa-arrows positioning-props" />
            ) : isSubject ? (
              <Apartment />
            ) : (
              <Room />
            )}
          </div>
          <span>{property.name}</span>
          {property.isTruncated && <Tooltip title="One or more sections of data truncated for this property, Those are highlighted with red border in corresponding page preview, Click here to redirect to the page.">
              <WarningIcon className="warning-icon" style={{ color: red[200], fontSize: 24 }} />
            </Tooltip>}
          {/* {isPropertyReadyForOvSync && <Tooltip title="Sync to OmniView.">
              <AutorenewIcon className="sync-icon" style={{ color: grey[700], fontSize: 24 }} />
            </Tooltip>} */}
          <span className="lable2">
            {enableDelete && isHovered ? <DeleteIcon className="del-icon" data-testid={`property-delete-item-${property.propertyType}`} onClick={e => {
                  e.stopPropagation()
                  onDelete(property)
                }} /> : property.propertyType}
          </span>
        </div>
      </React.Fragment>
  }
}

PropertyListItem.propTypes = {
  isSubject: PropTypes.bool,
  property: PropTypes.object,
  orderIndex: PropTypes.number,
  originalIndex: PropTypes.number,
  isDragging: PropTypes.bool,
  onDragOver: PropTypes.func,
  onDragStart: PropTypes.func,
  onDrop: PropTypes.func,
  dragMode: PropTypes.bool,
  gotoPropertyPreview: PropTypes.func,
  onDelete: PropTypes.func,
  enableDelete: PropTypes.bool,
  hasUnSavedChanges: PropTypes.bool
}

const mapStateToProps = state => ({
  hasUnSavedChanges: Comps.selectors.comps.resetflag(state)
})

export default connect(mapStateToProps)(PropertyListItem)
